export default "__VITE_ASSET__COOvo7oK__"